//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateNotificaciones } from "@/typings/store/plugins/easyFirestore/notificaciones";

const getters: GetterTree<StateNotificaciones, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const notificaciones = {
    firestorePath: "dev/v1/notificaciones",
    firestoreRefType: "collection",
    moduleName: "notificaciones",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default notificaciones;
